<template>
    <div>
        <!-- Home Start-->
        <section class="main-header bg-header" id="home">
            <div class="home-bg-img">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                <h1 class="banner-title text-lg-left text-center text-white text-uppercase">
                                    Serious Network Protection for South Texas Operations
                                </h1>
                                <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                    We design, secure, and support IT infrastructure for energy, industrial, and multi-site commercial operations in Laredo and the Eagle Ford region. We focus on uptime, security, and reliability—not one-time fixes.
                                </p>
                                <div class="mt-md-4 mb-4 text-lg-left text-center">
                                    <a href="#contact" class="btn theme-btn text-white">Request a Consultation</a>
                                    <a href="#contact" class="btn btn-outline-light text-white ml-2">Schedule a Site Review</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="banner-img-02 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <img src="assets/images/main-banner-01.png" class="img-fluid" alt="Network security for industrial operations in South Texas.">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Home End -->

        <!-- Who We Work With -->
        <section class="section bg-white" id="clients">
            <div class="container">
                <div class="title-section text-center">
                    <h2 class="title f-40">Your IT Partner for Critical Operations</h2>
                    <p class="para-text mx-auto">We provide specialized IT and security services for organizations in South Texas where network failure is not an option. Our deep experience in the region makes us the ideal partner for:</p>
                </div>
                <div class="row justify-content-center mt-4">
                    <ul class="list-group list-group-flush col-lg-8 text-center">
                      <li class="list-group-item">Energy and Oil & Gas Operators in the Eagle Ford Shale</li>
                      <li class="list-group-item">Industrial Facilities & Field Service Companies</li>
                      <li class="list-group-item">Logistics, Transportation & Distribution Yards</li>
                      <li class="list-group-item">Multi-Site Commercial & Fuel Networks</li>
                      <li class="list-group-item">Professional Offices that depend on uptime and data security</li>
                    </ul>
                </div>
            </div>
        </section>
        <!-- End Who We Work With -->

        <!-- Start Services section -->
        <section class="section bg-light" id="services">
            <div class="container">
                <div class="title-section">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle theme-color text-uppercase position-relative">SERVICES</h6>
                        <hr>
                    </div>
                    <h2 class="title text-md-left text-center f-40">Our Core Services for Your Operation</h2>
                     <p>We deliver robust solutions focused on reducing risk and maximizing uptime.</p>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <h3 class="my-3 theme-color text-sm-left text-center font-weight-medium h5">Network Protection & Firewalls</h3>
                                    <p class="para-text text-sm-left text-center mb-0">The foundation of your security. We design and deploy business-grade firewalls and segmented networks to protect your critical systems from internal and external threats.</p>
                                    <a href="/network-protection" class="btn btn-link">Learn About Network Protection</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <h3 class="my-3 theme-color text-sm-left text-center font-weight-medium h5">Managed IT Services</h3>
                                    <p class="para-text text-sm-left text-center mb-0">Proactive support for your essential systems. We provide 24/7 monitoring, patch management, data backup, and expert support to keep your operation running smoothly.</p>
                                     <a href="/managed-it-services" class="btn btn-link">Explore Our Managed IT</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <h3 class="my-3 theme-color text-sm-left text-center font-weight-medium h5">Oilfield & Remote Site IT</h3>
                                    <p class="para-text text-sm-left text-center mb-0">Connecting your most challenging environments. We deliver reliable networking, SCADA connectivity, and rugged solutions for remote sites across the Eagle Ford.</p>
                                     <a href="/oilfield-remote-it" class="btn btn-link">View Remote & Oilfield Solutions</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="mt-4">
                            <div class="hover-block p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <div class="features-inner-text text-sm-left text-center">
                                    <h3 class="my-3 theme-color text-sm-left text-center font-weight-medium h5">Camera & NVR Networks</h3>
                                    <p class="para-text text-sm-left text-center mb-0">Visibility and security for your assets. We design and install secure, commercial-grade IP camera and NVR networks for industrial and multi-site operations.</p>
                                     <a href="/camera-nvr-networks" class="btn btn-link">See Our Camera Solutions</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Services section -->

        <!-- Start Why Choose Us Section -->
        <section class="section" id="why-us">
            <div class="container">
                <div class="title-section">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle theme-color text-uppercase position-relative">EXPERTISE</h6>
                        <hr>
                    </div>
                    <h2 class="title text-md-left text-center f-40">Field-Tested Expertise in South Texas</h2>
                </div>
                <div class="row justify-content-center mt-4">
                    <div class="col-lg-4 col-sm-6">
                        <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                            <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Deep Industrial & Remote Site Experience</h5>
                            <p class="para-text text-md-left text-center mb-0">We have years of hands-on experience designing and supporting networks in dusty yards, remote well pads, and other challenging industrial settings. We know what works.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                            <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Focus on Uptime & Operational Continuity</h5>
                            <p class="para-text text-md-left text-center mb-0">Our goal is to build resilient systems that prevent downtime. We understand that every minute your network is down, your business is losing money.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hover-block aboutus-inner transition p-4 shadow wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                            <h5 class="my-3 theme-color text-md-left text-center font-weight-medium">Local Presence & Accountability</h5>
                            <p class="para-text text-md-left text-center mb-0">We are a Laredo-based company. You get direct access to local experts who are accountable for your success, not a remote helpdesk.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Why Choose Us Section -->

        <!-- Service Area & Spanish Block -->
        <section class="section bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <h2 class="title">On-Site Support for Distributed & Remote Operations</h2>
                        <p>Our team is equipped to provide on-site and remote support throughout Laredo, the Eagle Ford region, and greater South Texas, including Cotulla, Carrizo Springs, and Dilley. We specialize in supporting businesses with multiple or distributed sites.</p>
                        <a href="/service-area" class="btn btn-link">View Our Full Service Area</a>
                    </div>
                    <div class="col-md-4">
                        <h3>Expertos en Protección de Redes para Operaciones Críticas</h3>
                        <p>Servicios de TI y protección de redes para operaciones críticas en Laredo y el sur de Texas. Diseñamos e instalamos firewalls, redes seguras, cámaras y acceso remoto para que su operación funcione sin interrupciones y con mayor seguridad.</p>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Satrt Contact us -->
        <section class="section contactus-section" id="contact">
            <div class="container">
                <div class="title-section wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="subtitle-hr d-flex align-items-center">
                        <h6 class="subtitle theme-color text-uppercase position-relative">CONTACT</h6>
                        <hr>
                    </div>
                    <h2 class="title text-md-left text-center f-40">Improve Your Operational Security & Reliability</h2>
                    <p class="text-center">Ready for a serious IT partner? Contact us for a no-obligation consultation. We'll review your current setup, identify risks, and propose practical improvements to protect your operation.</p>
                </div>
                <div class="wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-12 py-4 contact-item">
                                    <h5>Email:</h5>
                                    <a href="mailto:contact@cynexsol.com">contact@cynexsol.com</a>
                                </div>
                                <div class="col-md-12 py-4 contact-item">
                                    <h5>Phone:</h5>
                                    <a href="tel:+19562821034">+1 (956) 282-1034</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <form @submit.prevent="submitForm">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input v-model="form.fname" name="fname" id="fname" type="text" class="form-control border-0" placeholder="First Name" required>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input v-model="form.lname" name="lname" id="lname" type="text" class="form-control border-0" placeholder="Last Name" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input v-model="form.email" name="email" id="email" type="email" class="form-control border-0" placeholder="Email" required>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input v-model="form.phone" name="phone" id="phone" type="phone" class="form-control border-0" placeholder="Phone" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <input v-model="form.subject" name="subject" id="subject" type="text" class="form-control border-0" placeholder="Subject" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <textarea v-model="form.comments" name="comments" id="comments" rows="6" class="form-control border-0" placeholder="Message" required></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 text-left">
                                        <button type="submit" class="mt-4 btn theme-btn contact-form-btn border-0">Request My Free Quote</button>
                                    </div>
                                </div>
                            </form>
                            <div v-if="responseMessage" :class="responseStatus">
                                {{ responseMessage }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Contact us -->
    </div>
</template>
<script>
    //WOW JS
    import { WOW } from 'wowjs';
    //OWL CAROUSEL JS
    import 'owl.carousel/dist/assets/owl.carousel.css';
    import 'owl.carousel';
import { data } from 'jquery';
    export default {
        name: 'index', mounted() {
            this.init();
        },
        data() {
            return {
                form: {
                    fname: "",
                    lname: "",
                    email: "",
                    phone: "",
                    subject: "",
                    comments: "",
                },
                responseMessage: "",
                responseStatus: "",
            };
        },
        methods: {
            async submitForm() {
                try {
                    const response = await fetch("https://formspree.io/f/xdkgdrnb", {
                        method: "POST",
                        headers: { 
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },
                        body: JSON.stringify({
                            fname: this.form.fname,
                            lname: this.form.lname,
                            email: this.form.email,
                            phone: this.form.phone,
                            subject: this.form.subject,
                            message: this.form.comments,
                        }),
                    });

                    if (!response.ok) {
                        throw new Error("Failed to send message.");
                    }

                    this.responseMessage = "Message sent!";
                    this.responseStatus = "text-success";
                    this.resetForm();
                    this.autoHideMessage();
                } catch (err) {
                    console.error(err);
                    this.responseMessage = "Failed to send message.";
                    this.responseStatus = "text-danger";
                    this.autoHideMessage();
                }
            },
            resetForm() {
                this.form = {
                    fname: "",
                    lname: "",
                    email: "",
                    phone: "",
                    subject: "",
                    comments: "",
                };
            },
            autoHideMessage() {
                // Clear any existing timeout to avoid overlapping
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }

                // Set a new timeout to clear the message after 5 seconds
                this.timeoutId = setTimeout(() => {
                    this.responseMessage = "";
                    this.responseStatus = "";
                    this.timeoutId = null; // Reset the timer ID
                }, 5000);
            },
            init() {
                this.initWowAnimation();
            },
            initWowAnimation() {
                var length = $('.wow').length;
                if (length >= 1) {
                    const wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: 0,
                    });
                    wow.init();
                }
            },
        }
    }
</script>
